import {
  ConsultationRequestApi,
  type GetConsultationRequestShareCodeResponse,
  type JoinConsultationRequestWithShareCode200Response,
  type JoinScheduledConsultationRequestWithShareCode200Response,
  ScheduledConsultationRequestApi
} from '@/generated'
import { globalApiConfig } from '@/services/telehealthApi/APIConfig'

export class CallService {
  static get consultationRequestApi() {
    return new ConsultationRequestApi(globalApiConfig)
  }

  static get scheduledConsultationRequestApi() {
    return new ScheduledConsultationRequestApi(globalApiConfig)
  }

  static async joinCall(
    consultationRequestId: string
  ): Promise<JoinConsultationRequestWithShareCode200Response> {
    return (await CallService.consultationRequestApi.joinCall(consultationRequestId)).data
  }

  static async joinWithConsultationShareCode(
    consultationShareCode: string
  ): Promise<JoinConsultationRequestWithShareCode200Response> {
    return (
      await CallService.consultationRequestApi.joinConsultationRequestWithShareCode(
        consultationShareCode
      )
    ).data
  }

  static async getConsultationShareCode(
    consultationRequestId: string
  ): Promise<GetConsultationRequestShareCodeResponse> {
    return (
      await CallService.consultationRequestApi.getConsultationRequestShareCode(
        consultationRequestId
      )
    ).data
  }

  static async getScheduledConsultationShareCode(
    consultationRequestId: string
  ): Promise<GetConsultationRequestShareCodeResponse> {
    return (
      await CallService.scheduledConsultationRequestApi.getScheduledConsultationRequestShareCode(
        consultationRequestId
      )
    ).data
  }

  static async endCall(consultationRequestId: string): Promise<void> {
    await CallService.consultationRequestApi.endCall(consultationRequestId)
  }

  static async joinScheduledCall(
    scheduledConsultationId: string
  ): Promise<JoinScheduledConsultationRequestWithShareCode200Response> {
    return (
      await CallService.scheduledConsultationRequestApi.joinScheduledCall(scheduledConsultationId)
    ).data
  }

  static async joinScheduledCallWithShareCode(
    scheduledConsultationSharedCode: string
  ): Promise<JoinScheduledConsultationRequestWithShareCode200Response> {
    return (
      await CallService.scheduledConsultationRequestApi.joinScheduledConsultationRequestWithShareCode(
        scheduledConsultationSharedCode
      )
    ).data
  }
}
